import { apiCall } from './gqlClient';
const GETEQUIPMENTS_QUERY = "\n  query getEquipments {\n    getEquipments\n    {\n      id\n\t\t\tname\n\t\t\ttype\n      ...fragments\n    }\n  }";
export const getEquipmentsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETEQUIPMENTS_QUERY,
    variables: {},
    fragments
  });
};